import getWindow from 'Utils/get-window';
const scrollTo = (x = 0, y = 0) => getWindow().scrollTo(x, y);
export default scrollTo;
